// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.login-body[data-v-330b219e] {\n  position: absolute;\n  inset: 0;\n  width: 100vw;\n  height: 100vh;\n  background: #fff;\n}\n#login[data-v-330b219e] {\n  width: 500px;\n  margin: 200px auto 0;\n  padding: 20px;\n}\n.loading[data-v-330b219e] {\n  width: 26%;\n}\n.btn[data-v-330b219e] {\n  width: 100%;\n}\na.forgot[data-v-330b219e] {\n  display: block;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
